import React from "react";
import { Link } from "react-router-dom";

const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#0A0A0C] border-t border-line mt-32">
    <div className="max-w-[1600px] mx-auto px-5 md:px-10 py-20">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-6">
          <h3 className="font-serif text-5xl md:text-7xl text-bone leading-none">
            The soul is <span className="italic text-crimson">woven</span>,<br />not stitched.
          </h3>
          <p className="text-ash mt-8 max-w-md leading-relaxed">
            TAMASHii — unisex ethnic wear celebrating the colour, craft and fire of the Indian subcontinent.
            Made in limited runs, in India.
          </p>
        </div>
        <div className="md:col-span-3 md:col-start-9">
          <p className="overline mb-6">Explore</p>
          <ul className="space-y-3 text-ash">
            <li><Link to="/shop" className="link-underline hover:text-bone">Collection</Link></li>
            <li><Link to="/cart" className="link-underline hover:text-bone">Cart</Link></li>
            <li><Link to="/admin/login" className="link-underline hover:text-bone">Atelier Login</Link></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="overline mb-6">Contact</p>
          <ul className="space-y-3 text-ash text-sm">
            <li><a href="tel:+918767267075" className="link-underline hover:text-bone">+91-876-726-7075</a></li>
            <li><a href="mailto:contact@gnkrventures.com" className="link-underline hover:text-bone">contact@gnkrventures.com</a></li>
            <li>Pune, India</li>
          </ul>
        </div>
      </div>
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mt-20 pt-8 border-t border-line gap-4">
        <p className="font-mono text-xs text-ash">© {new Date().getFullYear()} TAMASHii ATELIER — ALL RIGHTS RESERVED</p>
        <p className="font-mono text-xs text-ash tracking-[0.25em]">SPIRIT OF CLOTH</p>
      </div>
    </div>
  </footer>
);

export default Footer;
